import React from "react";
import CommonGrid from "./CommonGrid";
import { ColumnType } from "../../../../components/Grid/constants";
import { FormattedDate } from "react-intl";
import { ReleasedType, InspectionType, WorkingPositionHandoverProtocolType } from "../../enum";
import InspectionWorkingPositionControl from "../InspectionWorkingPositionControl";

import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import Tooltip from "@mui/material/Tooltip";

export default (props) => {
  const columns = [
    {
      field: "workingPosition.name",
      displayField: "workingPosition",
      label: "Funkce",
      type: ColumnType.TEXT,
      mapper: (field) => (field ? field.name : ""),
      width: "20%",
    },
    {
      field: "released.name",
      displayField: "released",
      label: "Uvolněnost",
      enum: ReleasedType,
      type: ColumnType.ENUM,
      width: "10%",
    },
    {
      field: "organization",
      label: "Organizace",
      type: ColumnType.TEXT,
      width: "15%",
    },
    {
      field: "ovmName",
      label: "Podpůrný orgán",
      type: ColumnType.TEXT,
      width: "20%",
    },
    {
      field: "start",
      label: "Začátek (zapsáno)",
      type: ColumnType.JSX,
      jsx: (row) => {
        return (
          <div>
            {row.start && <FormattedDate value={row.start} />}
            {row.writtenDateOfStart && " ("}
            {row.writtenDateOfStart && <FormattedDate value={row.writtenDateOfStart} />}
            {row.writtenDateOfStart && ")"}
          </div>
        );
      },
      width: "15%",
    },
    {
      field: "end",
      label: "Konec (zapsáno)",
      type: ColumnType.JSX,
      jsx: (row) => (
        <div>
          {row.end && <FormattedDate value={row.end} />}
          {row.writtenDateOfEnd && " ("}
          {row.writtenDateOfEnd && (
            <FormattedDate value={row.writtenDateOfEnd} />
          )}
          {row.writtenDateOfEnd && ")"}
        </div>
      ),
      width: "15%",
    },
  ];

  return <CommonGrid {...props} columns={columns} />;
};

export const WorkPositionGridWithOvmName = props => {
  const columns = [
    {
      field: 'workingPosition.name',
      displayField: 'workingPosition',
      label: 'Funkce',
      type: ColumnType.TEXT,
      mapper: field => field ? field.name : '',
      width: '30%'
    },
    {
      field: 'released.name',
      displayField: 'released',
      label: 'Uvolněnost',
      enum: ReleasedType,
      type: ColumnType.ENUM,
      width: '10%'
    },
    {
      field: 'organization',
      label: 'Organizace',
      type: ColumnType.TEXT,
      width: '20%'
    },
    {
      field: 'ovmName',
      label: 'Podpůrný orgán',
      type: ColumnType.TEXT,
      width: '20%'
    },
    {
      filterable: false,
      sortable: false,
      field: 'handoverProtocolIn',
      label: '',
      type: ColumnType.JSX,
      jsx: row => {
        return (row.start && props.generateHandoverProtocol && (!props.ovmId || row.ovmId === props.ovmId) &&
          <Tooltip
              title="Předávací protokol - vstupní"
              placement="top"
              arrow
              enterDelay={200}
          >
            <AssignmentOutlinedIcon style={{
              width: 18,
              height: 18,
              display: "block",
              color: "rgb(35, 98, 162)",
              margin: "0 -10px 0 3px"
            }} onClick={(e) => {
              e.stopPropagation();
              props.generateHandoverProtocol(row, WorkingPositionHandoverProtocolType.INGOING_STATEMENT);
            }}></AssignmentOutlinedIcon>
          </Tooltip>
        )
      }
    },
    {
      field: 'start',
      label: <span>Začátek <br/>(zapsáno)</span>,
      type: ColumnType.JSX,
      jsx: row => {
        return (
            <div style={{ textAlign: 'right' }}>
              <div>{row.start && <FormattedDate value={row.start} />}</div>
              {row.writtenDateOfStart && <div>({<FormattedDate value={row.writtenDateOfStart} />})</div>}
            </div>
        )
      },
      width: '10%'
    },
    {
      filterable: false,
      sortable: false,
      field: 'handoverProtocolOut',
      label: '',
      type: ColumnType.JSX,
      jsx: row => {
        return (row.end && props.generateHandoverProtocol && (!props.ovmId || row.ovmId === props.ovmId) &&
          <Tooltip
              title="Předávací protokol - výstupní"
              placement="top"
              arrow
              enterDelay={200}
          >
            <AssignmentOutlinedIcon style={{
              width: 18,
              height: 18,
              display: "block",
              color: "rgb(35, 98, 162)",
              margin: "0 -10px 0 3px"
            }} onClick={(e) => {
              e.stopPropagation();
              props.generateHandoverProtocol(row, WorkingPositionHandoverProtocolType.OUTGOING_STATEMENT);
            }}></AssignmentOutlinedIcon>
          </Tooltip>
        )
      }
    },
    {
      field: 'end',
      label: <span>Konec <br/>(zapsáno)</span>,
      type: ColumnType.JSX,
      jsx: row => (
          <div style={{ textAlign: 'right', wordWrap: 'break-word' }}>
            <div>{row.end && <FormattedDate value={row.end} />}</div>
            {row.writtenDateOfEnd && <div>(<FormattedDate value={row.writtenDateOfEnd} />)</div>}
          </div>
      ),
      width: '10%'
    },
    {
      field: "ingoingDeadline",
      label: <span>Lhůta pro <br/>vstupní oznámení do</span>,
      type: ColumnType.DATE,
      width: "5%",
    },
    {
      field: "outgoingDeadline",
      label: <span>Lhůta pro <br/>výstupní oznámení do</span>,
      type: ColumnType.DATE,
      width: "5%",
    },
  ];

  return <CommonGrid {...props} columns={columns} />
}

export const WorkPositionGridInternal = props => {
  const columns = [
    {
      sortable: false,
      field: 'inspection-ongoing',
      label: '',
      type: ColumnType.JSX,
      width: '3%',
      jsx: row => {
        return <InspectionWorkingPositionControl
                workingPosition={row}
                inspectionType={InspectionType.ONGOING_STATEMENT}
                administrativeAutorities={props.administrativeAutorities}
                onInspectionResult={props.onWorkingPositionInspectionResult}
                onInspectionEdit={props.onInspectionEdit} />
      }
    },
    {
      field: 'workingPosition.name',
      displayField: 'workingPosition',
      label: 'Funkce',
      type: ColumnType.TEXT,
      mapper: field => field ? field.name : '',
      width: '30%'
    },
    {
      field: 'released.name',
      displayField: 'released',
      label: 'Uvolněnost',
      enum: ReleasedType,
      type: ColumnType.ENUM,
      width: '10%'
    },
    {
      field: 'organization',
      label: 'Organizace',
      type: ColumnType.TEXT,
      width: '20%'
    },
    {
      field: 'ovmName',
      label: 'Podpůrný orgán',
      type: ColumnType.TEXT,
      width: '20%'
    },
    {
      sortable: false,
      field: 'inspection-ingoing',
      label: '',
      type: ColumnType.JSX,
      width: '3%',
      jsx: row => {
        return <InspectionWorkingPositionControl
                workingPosition={row}
                inspectionType={InspectionType.INGOING_STATEMENT}
                administrativeAutorities={props.administrativeAutorities}
                onInspectionResult={props.onWorkingPositionInspectionResult}
                onInspectionEdit={props.onInspectionEdit} />
      }
    },
    {
      field: 'start',
      label: <span>Začátek <br/>(zapsáno)</span>,
      type: ColumnType.JSX,
      jsx: row => {
        return (
            <div style={{ textAlign: 'right' }}>
              <div>{row.start && <FormattedDate value={row.start} />}</div>
              {row.writtenDateOfStart && <div>({<FormattedDate value={row.writtenDateOfStart} />})</div>}
            </div>
        )
      },
      width: '10%'
    },
    {
      sortable: false,
      field: 'inspection-outgoing',
      label: '',
      type: ColumnType.JSX,
      width: '3%',
      jsx: row => {
        return <InspectionWorkingPositionControl
                workingPosition={row}
                inspectionType={InspectionType.OUTGOING_STATEMENT}
                administrativeAutorities={props.administrativeAutorities}
                onInspectionResult={props.onWorkingPositionInspectionResult}
                onInspectionEdit={props.onInspectionEdit} />
      }
    },
    {
      field: 'end',
      label: <span>Konec <br/>(zapsáno)</span>,
      type: ColumnType.JSX,
      jsx: row => (
          <div style={{ textAlign: 'right', wordWrap: 'break-word' }}>
            <div>{row.end && <FormattedDate value={row.end} />}</div>
            {row.writtenDateOfEnd && <div>(<FormattedDate value={row.writtenDateOfEnd} />)</div>}
          </div>
      ),
      width: '10%'
    },
    {
      field: "ingoingDeadline",
      label: <span>Lhůta pro <br/>vstupní oznámení do</span>,
      type: ColumnType.DATE,
      width: "5%",
    },
    {
      field: "outgoingDeadline",
      label: <span>Lhůta pro <br/>výstupní oznámení do</span>,
      type: ColumnType.DATE,
      width: "5%",
    },
  ];

  return <CommonGrid {...props} columns={columns} />
}